export const DESCRIPTION_WINDOW_INIT_SIZE = {
    width: 300,
    height: 500,
}

export const NAVBAR_HEIGHT = 58

export const DESCRIPTION_WINDOW_INIT_COORDINATES = {
    x: window.innerWidth / 2 - DESCRIPTION_WINDOW_INIT_SIZE.width / 2,
    y: NAVBAR_HEIGHT,
}

